// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-faq-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1120px;
  --epw-radius: 14px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 8px 28px var(--shadow);
}

    .epw-faq-page, .epw-faq-page * { box-sizing: border-box; }

    .epw-faq-page {
      font-family:
        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
      background: var(--epw-white);
      color: var(--epw-ink);
      line-height: 1.65;
    }

    .epw-faq-page {
      width: 100%;
    }

    .epw-faq-hero {
      background:
        linear-gradient(135deg, rgba(200, 16, 46, 0.96), rgba(130, 10, 34, 0.96));
      color: var(--epw-white);
      padding: 72px 24px 64px;
    }

    .epw-faq-hero-inner,
    .epw-faq-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      opacity: 0.9;
    }

    .epw-faq-hero h1 {
      margin: 0;
      max-width: 760px;
      font-size: clamp(2.1rem, 5vw, 4rem);
      line-height: 1.08;
      letter-spacing: -0.035em;
    }

    .epw-faq-hero p {
      max-width: 780px;
      margin: 22px 0 0;
      font-size: clamp(1rem, 2vw, 1.18rem);
      opacity: 0.94;
    }

    .epw-faq-main {
      padding: 44px 24px 72px;
    }

    .epw-faq-toolbar {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 14px;
      align-items: center;
      margin-bottom: 22px;
    }

    .epw-faq-search {
      position: relative;
    }

    .epw-faq-search input {
      width: 100%;
      min-height: 50px;
      border: 1px solid var(--epw-line);
      border-radius: 12px;
      padding: 0 16px 0 46px;
      font: inherit;
      color: var(--epw-ink);
      background: var(--epw-white);
      outline: none;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .epw-faq-search input:focus {
      border-color: var(--epw-red);
      box-shadow: 0 0 0 4px rgba(200, 16, 46, 0.1);
    }

    .epw-search-icon {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--epw-muted);
      pointer-events: none;
      font-size: 1.05rem;
    }

    .epw-faq-actions {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    .epw-btn {
      min-height: 46px;
      border: 1px solid var(--epw-line);
      border-radius: 10px;
      padding: 0 14px;
      background: var(--epw-white);
      color: var(--epw-ink);
      font: inherit;
      font-weight: 700;
      cursor: pointer;
      transition: 0.2s ease;
    }

    .epw-btn:hover,
    .epw-btn:focus-visible {
      border-color: var(--epw-red);
      color: var(--epw-red);
      outline: none;
    }

    .epw-faq-layout {
      display: grid;
      grid-template-columns: 250px minmax(0, 1fr);
      gap: 28px;
      align-items: start;
    }

    .epw-faq-nav {
      position: sticky;
      top: 24px;
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
      padding: 14px;
    }

    .epw-faq-nav-title {
      margin: 4px 8px 10px;
      font-size: 0.78rem;
      color: var(--epw-muted);
      font-weight: 800;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .epw-faq-nav a {
      display: block;
      padding: 10px 10px;
      border-radius: 9px;
      color: var(--epw-ink);
      text-decoration: none;
      font-size: 0.94rem;
      font-weight: 650;
    }

    .epw-faq-nav a:hover,
    .epw-faq-nav a:focus-visible {
      background: var(--epw-soft);
      color: var(--epw-red);
      outline: none;
    }

    .epw-faq-content {
      min-width: 0;
    }

    .epw-faq-section {
      scroll-margin-top: 24px;
      margin-bottom: 34px;
    }

    .epw-faq-section h2 {
      margin: 0 0 14px;
      font-size: clamp(1.35rem, 2.2vw, 1.75rem);
      line-height: 1.25;
      letter-spacing: -0.02em;
    }

    .epw-faq-item {
      border: 1px solid var(--epw-line);
      border-radius: 12px;
      background: var(--epw-white);
      margin-bottom: 10px;
      overflow: hidden;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .epw-faq-item:hover {
      border-color: var(--epw-line);
    }

    .epw-faq-item[open] {
      border-color: rgba(200, 16, 46, 0.32);
      box-shadow: 0 8px 20px rgba(16, 24, 40, 0.055);
    }

    .epw-faq-item summary {
      position: relative;
      list-style: none;
      cursor: pointer;
      padding: 18px 52px 18px 20px;
      font-weight: 780;
      line-height: 1.4;
    }

    .epw-faq-item summary::-webkit-details-marker {
      display: none;
    }

    .epw-faq-item summary::after {
      content: "+";
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--epw-red);
      font-size: 1.45rem;
      font-weight: 500;
    }

    .epw-faq-item[open] summary::after {
      content: "–";
    }

    .epw-faq-answer {
      padding: 0 20px 20px;
      color: var(--epw-muted);
    }

    .epw-faq-answer p {
      margin: 0 0 12px;
    }

    .epw-faq-answer p:last-child {
      margin-bottom: 0;
    }

    .epw-faq-answer ul {
      margin: 10px 0 0;
      padding-left: 22px;
    }

    .epw-faq-answer li + li {
      margin-top: 5px;
    }

    .epw-faq-answer strong {
      color: var(--epw-ink);
    }

    .epw-plan-card {
      border-left: 4px solid var(--epw-red);
      background: var(--epw-soft);
      padding: 14px 16px;
      border-radius: 10px;
      margin-top: 12px;
    }

    .epw-no-results {
      display: none;
      border: 1px dashed var(--epw-line);
      border-radius: 12px;
      padding: 24px;
      color: var(--epw-muted);
      text-align: center;
    }

    .epw-faq-cta {
      margin-top: 46px;
      background: var(--epw-band-bg);
      color: #ffffff;
      border-radius: 18px;
      padding: 30px;
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 22px;
      align-items: center;
    }

    .epw-faq-cta h2 {
      margin: 0 0 8px;
      font-size: clamp(1.45rem, 2.5vw, 2rem);
    }

    .epw-faq-cta p {
      margin: 0;
      color: #d5d9e2;
    }

    .epw-cta-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      padding: 0 18px;
      border-radius: 10px;
      background: var(--epw-red);
      color: var(--epw-white);
      text-decoration: none;
      font-weight: 800;
      white-space: nowrap;
    }

    .epw-cta-button:hover,
    .epw-cta-button:focus-visible {
      background: var(--epw-red-dark);
      outline: none;
    }

    .epw-footnote {
      margin-top: 18px;
      font-size: 0.88rem;
      color: var(--epw-muted);
    }

    @media (max-width: 900px) {
      .epw-faq-layout {
        grid-template-columns: 1fr;
      }

      .epw-faq-nav {
        position: static;
        display: flex;
        gap: 6px;
        overflow-x: auto;
        white-space: nowrap;
        box-shadow: none;
      }

      .epw-faq-nav-title {
        display: none;
      }

      .epw-faq-nav a {
        flex: 0 0 auto;
        background: var(--epw-soft);
      }
    }

    @media (max-width: 680px) {
      .epw-faq-hero {
        padding: 54px 20px 48px;
      }

      .epw-faq-main {
        padding: 30px 18px 54px;
      }

      .epw-faq-toolbar {
        grid-template-columns: 1fr;
      }

      .epw-faq-actions {
        width: 100%;
      }

      .epw-btn {
        flex: 1 1;
      }

      .epw-faq-cta {
        grid-template-columns: 1fr;
      }

      .epw-cta-button {
        width: 100%;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/FaqPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;AACxC;;IAEI,iCAAiC,sBAAsB,EAAE;;IAEzD;MACE;;8BAEwB;MACxB,4BAA4B;MAC5B,qBAAqB;MACrB,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE;iFAC2E;MAC3E,uBAAuB;MACvB,uBAAuB;IACzB;;IAEA;;MAEE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;MACzB,YAAY;IACd;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,mCAAmC;MACnC,iBAAiB;MACjB,wBAAwB;IAC1B;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,oCAAoC;MACpC,aAAa;IACf;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,0CAA0C;MAC1C,SAAS;MACT,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,iCAAiC;MACjC,mBAAmB;MACnB,sBAAsB;MACtB,aAAa;MACb,qBAAqB;MACrB,4BAA4B;MAC5B,aAAa;MACb,wDAAwD;IAC1D;;IAEA;MACE,4BAA4B;MAC5B,4CAA4C;IAC9C;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,2BAA2B;MAC3B,uBAAuB;MACvB,oBAAoB;MACpB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,QAAQ;MACR,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,iCAAiC;MACjC,mBAAmB;MACnB,eAAe;MACf,4BAA4B;MAC5B,qBAAqB;MACrB,aAAa;MACb,gBAAgB;MAChB,eAAe;MACf,qBAAqB;IACvB;;IAEA;;MAEE,4BAA4B;MAC5B,qBAAqB;MACrB,aAAa;IACf;;IAEA;MACE,aAAa;MACb,2CAA2C;MAC3C,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,iCAAiC;MACjC,gCAAgC;MAChC,4BAA4B;MAC5B,6BAA6B;MAC7B,aAAa;IACf;;IAEA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,uBAAuB;MACvB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,cAAc;MACd,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;;MAEE,2BAA2B;MAC3B,qBAAqB;MACrB,aAAa;IACf;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,yCAAyC;MACzC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,iCAAiC;MACjC,mBAAmB;MACnB,4BAA4B;MAC5B,mBAAmB;MACnB,gBAAgB;MAChB,wDAAwD;IAC1D;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,qCAAqC;MACrC,8CAA8C;IAChD;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,4BAA4B;MAC5B,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,QAAQ;MACR,2BAA2B;MAC3B,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,oBAAoB;MACpB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qCAAqC;MACrC,2BAA2B;MAC3B,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,kCAAkC;MAClC,mBAAmB;MACnB,aAAa;MACb,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,8BAA8B;MAC9B,cAAc;MACd,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,0CAA0C;MAC1C,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,sCAAsC;IACxC;;IAEA;MACE,SAAS;MACT,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,0BAA0B;MAC1B,uBAAuB;MACvB,qBAAqB;MACrB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;;MAEE,+BAA+B;MAC/B,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,uBAAuB;IACzB;;IAEA;MACE;QACE,0BAA0B;MAC5B;;MAEA;QACE,gBAAgB;QAChB,aAAa;QACb,QAAQ;QACR,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;MAClB;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,cAAc;QACd,2BAA2B;MAC7B;IACF;;IAEA;MACE;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,WAAW;MACb;;MAEA;QACE,SAAO;MACT;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,WAAW;MACb;IACF","sourcesContent":[".epw-faq-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1120px;\n  --epw-radius: 14px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 8px 28px var(--shadow);\n}\n\n    .epw-faq-page, .epw-faq-page * { box-sizing: border-box; }\n\n    .epw-faq-page {\n      font-family:\n        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n        \"Segoe UI\", sans-serif;\n      background: var(--epw-white);\n      color: var(--epw-ink);\n      line-height: 1.65;\n    }\n\n    .epw-faq-page {\n      width: 100%;\n    }\n\n    .epw-faq-hero {\n      background:\n        linear-gradient(135deg, rgba(200, 16, 46, 0.96), rgba(130, 10, 34, 0.96));\n      color: var(--epw-white);\n      padding: 72px 24px 64px;\n    }\n\n    .epw-faq-hero-inner,\n    .epw-faq-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      font-size: 0.8rem;\n      font-weight: 800;\n      letter-spacing: 0.12em;\n      text-transform: uppercase;\n      opacity: 0.9;\n    }\n\n    .epw-faq-hero h1 {\n      margin: 0;\n      max-width: 760px;\n      font-size: clamp(2.1rem, 5vw, 4rem);\n      line-height: 1.08;\n      letter-spacing: -0.035em;\n    }\n\n    .epw-faq-hero p {\n      max-width: 780px;\n      margin: 22px 0 0;\n      font-size: clamp(1rem, 2vw, 1.18rem);\n      opacity: 0.94;\n    }\n\n    .epw-faq-main {\n      padding: 44px 24px 72px;\n    }\n\n    .epw-faq-toolbar {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) auto;\n      gap: 14px;\n      align-items: center;\n      margin-bottom: 22px;\n    }\n\n    .epw-faq-search {\n      position: relative;\n    }\n\n    .epw-faq-search input {\n      width: 100%;\n      min-height: 50px;\n      border: 1px solid var(--epw-line);\n      border-radius: 12px;\n      padding: 0 16px 0 46px;\n      font: inherit;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      outline: none;\n      transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    }\n\n    .epw-faq-search input:focus {\n      border-color: var(--epw-red);\n      box-shadow: 0 0 0 4px rgba(200, 16, 46, 0.1);\n    }\n\n    .epw-search-icon {\n      position: absolute;\n      left: 16px;\n      top: 50%;\n      transform: translateY(-50%);\n      color: var(--epw-muted);\n      pointer-events: none;\n      font-size: 1.05rem;\n    }\n\n    .epw-faq-actions {\n      display: flex;\n      gap: 8px;\n      flex-wrap: wrap;\n    }\n\n    .epw-btn {\n      min-height: 46px;\n      border: 1px solid var(--epw-line);\n      border-radius: 10px;\n      padding: 0 14px;\n      background: var(--epw-white);\n      color: var(--epw-ink);\n      font: inherit;\n      font-weight: 700;\n      cursor: pointer;\n      transition: 0.2s ease;\n    }\n\n    .epw-btn:hover,\n    .epw-btn:focus-visible {\n      border-color: var(--epw-red);\n      color: var(--epw-red);\n      outline: none;\n    }\n\n    .epw-faq-layout {\n      display: grid;\n      grid-template-columns: 250px minmax(0, 1fr);\n      gap: 28px;\n      align-items: start;\n    }\n\n    .epw-faq-nav {\n      position: sticky;\n      top: 24px;\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n      padding: 14px;\n    }\n\n    .epw-faq-nav-title {\n      margin: 4px 8px 10px;\n      font-size: 0.78rem;\n      color: var(--epw-muted);\n      font-weight: 800;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n    }\n\n    .epw-faq-nav a {\n      display: block;\n      padding: 10px 10px;\n      border-radius: 9px;\n      color: var(--epw-ink);\n      text-decoration: none;\n      font-size: 0.94rem;\n      font-weight: 650;\n    }\n\n    .epw-faq-nav a:hover,\n    .epw-faq-nav a:focus-visible {\n      background: var(--epw-soft);\n      color: var(--epw-red);\n      outline: none;\n    }\n\n    .epw-faq-content {\n      min-width: 0;\n    }\n\n    .epw-faq-section {\n      scroll-margin-top: 24px;\n      margin-bottom: 34px;\n    }\n\n    .epw-faq-section h2 {\n      margin: 0 0 14px;\n      font-size: clamp(1.35rem, 2.2vw, 1.75rem);\n      line-height: 1.25;\n      letter-spacing: -0.02em;\n    }\n\n    .epw-faq-item {\n      border: 1px solid var(--epw-line);\n      border-radius: 12px;\n      background: var(--epw-white);\n      margin-bottom: 10px;\n      overflow: hidden;\n      transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    }\n\n    .epw-faq-item:hover {\n      border-color: var(--epw-line);\n    }\n\n    .epw-faq-item[open] {\n      border-color: rgba(200, 16, 46, 0.32);\n      box-shadow: 0 8px 20px rgba(16, 24, 40, 0.055);\n    }\n\n    .epw-faq-item summary {\n      position: relative;\n      list-style: none;\n      cursor: pointer;\n      padding: 18px 52px 18px 20px;\n      font-weight: 780;\n      line-height: 1.4;\n    }\n\n    .epw-faq-item summary::-webkit-details-marker {\n      display: none;\n    }\n\n    .epw-faq-item summary::after {\n      content: \"+\";\n      position: absolute;\n      right: 20px;\n      top: 50%;\n      transform: translateY(-50%);\n      color: var(--epw-red);\n      font-size: 1.45rem;\n      font-weight: 500;\n    }\n\n    .epw-faq-item[open] summary::after {\n      content: \"–\";\n    }\n\n    .epw-faq-answer {\n      padding: 0 20px 20px;\n      color: var(--epw-muted);\n    }\n\n    .epw-faq-answer p {\n      margin: 0 0 12px;\n    }\n\n    .epw-faq-answer p:last-child {\n      margin-bottom: 0;\n    }\n\n    .epw-faq-answer ul {\n      margin: 10px 0 0;\n      padding-left: 22px;\n    }\n\n    .epw-faq-answer li + li {\n      margin-top: 5px;\n    }\n\n    .epw-faq-answer strong {\n      color: var(--epw-ink);\n    }\n\n    .epw-plan-card {\n      border-left: 4px solid var(--epw-red);\n      background: var(--epw-soft);\n      padding: 14px 16px;\n      border-radius: 10px;\n      margin-top: 12px;\n    }\n\n    .epw-no-results {\n      display: none;\n      border: 1px dashed var(--epw-line);\n      border-radius: 12px;\n      padding: 24px;\n      color: var(--epw-muted);\n      text-align: center;\n    }\n\n    .epw-faq-cta {\n      margin-top: 46px;\n      background: var(--epw-band-bg);\n      color: #ffffff;\n      border-radius: 18px;\n      padding: 30px;\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) auto;\n      gap: 22px;\n      align-items: center;\n    }\n\n    .epw-faq-cta h2 {\n      margin: 0 0 8px;\n      font-size: clamp(1.45rem, 2.5vw, 2rem);\n    }\n\n    .epw-faq-cta p {\n      margin: 0;\n      color: #d5d9e2;\n    }\n\n    .epw-cta-button {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 48px;\n      padding: 0 18px;\n      border-radius: 10px;\n      background: var(--epw-red);\n      color: var(--epw-white);\n      text-decoration: none;\n      font-weight: 800;\n      white-space: nowrap;\n    }\n\n    .epw-cta-button:hover,\n    .epw-cta-button:focus-visible {\n      background: var(--epw-red-dark);\n      outline: none;\n    }\n\n    .epw-footnote {\n      margin-top: 18px;\n      font-size: 0.88rem;\n      color: var(--epw-muted);\n    }\n\n    @media (max-width: 900px) {\n      .epw-faq-layout {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-faq-nav {\n        position: static;\n        display: flex;\n        gap: 6px;\n        overflow-x: auto;\n        white-space: nowrap;\n        box-shadow: none;\n      }\n\n      .epw-faq-nav-title {\n        display: none;\n      }\n\n      .epw-faq-nav a {\n        flex: 0 0 auto;\n        background: var(--epw-soft);\n      }\n    }\n\n    @media (max-width: 680px) {\n      .epw-faq-hero {\n        padding: 54px 20px 48px;\n      }\n\n      .epw-faq-main {\n        padding: 30px 18px 54px;\n      }\n\n      .epw-faq-toolbar {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-faq-actions {\n        width: 100%;\n      }\n\n      .epw-btn {\n        flex: 1;\n      }\n\n      .epw-faq-cta {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-cta-button {\n        width: 100%;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
